import React, { PropTypes, Component } from 'react'
import moment from 'moment-timezone'
import cx from 'classnames'

import SearchOutOfCoverageArea from '../SearchOutOfCoverageArea'
import SearchAvailabilityCalendar from '../SearchAvailabilityCalendar'
import './SearchNoResults.scss'
import { searchStatus } from '@src/globals'
import { formatDate } from 'utils/dates'

class SearchNoResults extends Component {
  constructor (props) {
    super(props)
  }

  render () {
    const { date, time, neighborhood, status } = this.props.searchProps

    const resultsCard = status => {
      switch (status) {
        case searchStatus.UNAVAILABLE_MUNICIPALITY:
          return (
            <div>
              <SearchOutOfCoverageArea
                neighborhood={neighborhood}
                coordinates={this.props.searchProps.coordinates}
                settings={
                  {
                    skills: this.props.searchProps.skills,
                    preferences: this.props.searchProps.preferences
                  }
                }
                status={status}
              />
            </div>
          )
        case searchStatus.NO_RESULTS:
        default:
          const formattedDate = formatDate('dddd D [de] MMMM [a las] h A', date + ' ' + time)

          return (
            <div className='SearchNoResults'>
              <h3>Lo sentimos :'(</h3>

              <p>
                No tenemos aliadas disponibles el <strong>{formattedDate}</strong>.
              </p>

              <SearchAvailabilityCalendar
                searchProps={ this.props.searchProps }
              />
            </div>
          )
      }
    }

    return resultsCard(this.props.status)
  }
}

SearchNoResults.displayName = 'SearchNoResults'
SearchNoResults.propTypes = {
  neighborhood: PropTypes.string.isRequired,
  coordinates: PropTypes.shape({
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired
  }).isRequired,
  settings: PropTypes.shape({
    skills: PropTypes.array,
    preferences: PropTypes.array
  }),
  status: PropTypes.string.isRequired
}
SearchNoResults.defaultProps = {}

export default SearchNoResults



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/Search/components/SearchResults/components/SearchNoResults/SearchNoResults.js